<!-- SwipFx Orders Page (Bootstrap 5) -->
<!-- Tabs need bootstrap.bundle.js -->
<div class="min-vh-100 bg-light">
    <app-header [page]="'Admin'"></app-header>
<main class="container py-4">

  <div class="d-flex justify-content-between align-items-center mb-4">
    <div>
      <h4 class="fw-bold mb-0">Compliance Admin Dashboard</h4>
      <div class="text-muted small">
        Overview of compliance setup and application review activity
      </div>
    </div>

    <div class="d-flex gap-2">
      <a class="btn btn-outline-secondary btn-sm" routerLink="/admin/compliance/setup-guide">
        Setup Guide
      </a>
      <button class="btn btn-primary btn-sm" (click)="load()">
        Refresh
      </button>
    </div>
  </div>

  <div *ngIf="loading" class="text-center py-4">
    <div class="spinner-border"></div>
  </div>

  <div *ngIf="error" class="alert alert-danger">
    {{ error }}
  </div>

  <div class="row g-4 mb-4" *ngIf="!loading">
    <div class="col-md-3">
      <div class="card shadow-sm border-0 h-100">
        <div class="card-body">
          <div class="text-muted small">Jurisdictions</div>
          <div class="fw-bold fs-3">{{ counts.jurisdictions }}</div>
          <div class="mt-3">
            <a class="btn btn-outline-primary btn-sm" routerLink="/admin/compliance/jurisdictions">
              Open
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-3">
      <div class="card shadow-sm border-0 h-100">
        <div class="card-body">
          <div class="text-muted small">Tiers</div>
          <div class="fw-bold fs-3">{{ counts.tiers }}</div>
          <div class="mt-3">
            <a class="btn btn-outline-primary btn-sm" routerLink="/admin/compliance/tiers">
              Open
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-3">
      <div class="card shadow-sm border-0 h-100">
        <div class="card-body">
          <div class="text-muted small">Policies</div>
          <div class="fw-bold fs-3">{{ counts.policies }}</div>
          <div class="mt-3">
            <a class="btn btn-outline-primary btn-sm" routerLink="/admin/compliance/policies">
              Open
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-3">
      <div class="card shadow-sm border-0 h-100">
        <div class="card-body">
          <div class="text-muted small">Submitted Applications</div>
          <div class="fw-bold fs-3">{{ counts.submittedApplications }}</div>
          <div class="mt-3">
            <a class="btn btn-outline-primary btn-sm" routerLink="/admin/compliance/applications">
              Review Queue
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row g-4 mb-4" *ngIf="!loading">
    <div class="col-md-4">
      <div class="card shadow-sm border-0 h-100 border-warning-subtle">
        <div class="card-body">
          <div class="text-muted small">Under Review</div>
          <div class="fw-bold fs-3">{{ counts.underReviewApplications }}</div>
          <div class="small text-muted mt-2">
            Applications currently being processed by compliance staff.
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-4">
      <div class="card shadow-sm border-0 h-100 border-success-subtle">
        <div class="card-body">
          <div class="text-muted small">Approved</div>
          <div class="fw-bold fs-3">{{ counts.approvedApplications }}</div>
          <div class="small text-muted mt-2">
            Applications that have successfully passed review.
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-4">
      <div class="card shadow-sm border-0 h-100 border-danger-subtle">
        <div class="card-body">
          <div class="text-muted small">Rejected</div>
          <div class="fw-bold fs-3">{{ counts.rejectedApplications }}</div>
          <div class="small text-muted mt-2">
            Applications that need correction or resubmission.
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row g-4 mb-4" *ngIf="!loading">
    <div class="col-md-3">
      <div class="card shadow-sm border-0 h-100 border-primary-subtle">
        <div class="card-body">
          <div class="text-muted small">Open Risk Flags</div>
          <div class="fw-bold fs-3">{{ riskCounts.openFlags }}</div>
          <div class="mt-3">
            <a class="btn btn-outline-primary btn-sm" routerLink="/admin/compliance-flags">
              Open Flags
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-3">
      <div class="card shadow-sm border-0 h-100 border-success-subtle">
        <div class="card-body">
          <div class="text-muted small">Resolved Flags</div>
          <div class="fw-bold fs-3">{{ riskCounts.resolvedFlags }}</div>
          <div class="small text-muted mt-2">
            Flags that have already been reviewed and closed.
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-3">
      <div class="card shadow-sm border-0 h-100 border-danger-subtle">
        <div class="card-body">
          <div class="text-muted small">High Risk Open Flags</div>
          <div class="fw-bold fs-3 text-danger">{{ riskCounts.highRiskOpenFlags }}</div>
          <div class="small text-muted mt-2">
            Open flags with elevated risk scores requiring faster attention.
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-3">
      <div class="card shadow-sm border-0 h-100 border-warning-subtle">
        <div class="card-body">
          <div class="text-muted small">Flagged Users</div>
          <div class="fw-bold fs-3">{{ riskCounts.flaggedUsers }}</div>
          <div class="small text-muted mt-2">
            Unique users currently associated with open risk flags.
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row g-4" *ngIf="!loading">
    <div class="col-lg-8">
      <div class="card shadow-sm border-0">
        <div class="card-body">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <div>
              <h5 class="mb-0">Recent Applications</h5>
              <div class="text-muted small">Latest submissions and review activity</div>
            </div>

            <a class="btn btn-outline-secondary btn-sm" routerLink="/admin/compliance/applications">
              View All
            </a>
          </div>

          <div *ngIf="!recentApplications.length" class="text-muted small">
            No recent applications found.
          </div>

          <div class="table-responsive" *ngIf="recentApplications.length">
            <table class="table table-hover align-middle mb-0">
              <thead class="table-light">
                <tr>
                  <th>User</th>
                  <th>Country</th>
                  <th>Tier</th>
                  <th>Status</th>
                  <th>Started</th>
                </tr>
              </thead>

              <tbody>
                <tr *ngFor="let item of recentApplications">
                  <td>
                    <div class="fw-semibold">{{ item.fullName }}</div>
                    <div class="small text-muted">{{ item.email }}</div>
                  </td>
                  <td>{{ item.jurisdictionCode }}</td>
                  <td>{{ item.tierCode }}</td>
                  <td>
                    <span class="badge" [ngClass]="getStatusClass(item.status)">
                      {{ item.status }}
                    </span>
                  </td>
                  <td>{{ item.startedAt | date:'medium' }}</td>
                </tr>
              </tbody>
            </table>
          </div>

        </div>
      </div>
    </div>

    <div class="col-lg-4">
      <div class="card shadow-sm border-0 mb-4">
        <div class="card-body">
          <h5 class="mb-3">Quick Actions</h5>

          <div class="d-grid gap-2">
            <a class="btn btn-outline-primary btn-sm" routerLink="/admin/compliance/jurisdictions/new">
              New Jurisdiction
            </a>
            <a class="btn btn-outline-primary btn-sm" routerLink="/admin/compliance/tiers/new">
              New Tier
            </a>
            <a class="btn btn-outline-primary btn-sm" routerLink="/admin/compliance/policies/new">
              New Policy
            </a>
            <a class="btn btn-outline-secondary btn-sm" routerLink="/admin/compliance/setup-guide">
              Open Setup Guide
            </a>
          </div>
        </div>
      </div>

      <div class="card shadow-sm border-0 mb-4">
        <div class="card-body">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <div>
              <h5 class="mb-0">Recent Open Flags</h5>
              <div class="text-muted small">Latest risk and compliance alerts</div>
            </div>

            <a class="btn btn-outline-secondary btn-sm" routerLink="/admin/compliance-flags">
              View All
            </a>
          </div>

          <div *ngIf="!recentFlags.length" class="text-muted small">
            No open compliance flags found.
          </div>

          <div *ngIf="recentFlags.length" class="d-grid gap-2">
            <div
              *ngFor="let item of recentFlags"
              class="border rounded p-2 bg-light-subtle">
              <div class="d-flex justify-content-between align-items-start gap-2">
                <div>
                  <div class="fw-semibold">{{ item.userName || 'Unknown User' }}</div>
                  <div class="small text-muted">{{ item.email || 'No email' }}</div>
                </div>

                <span class="badge" [ngClass]="getRiskClass(item.riskLevel)">
                  {{ item.riskLevel }}
                </span>
              </div>

              <div class="small mt-2">{{ item.reason }}</div>
              <div class="small text-muted mt-1">
                {{ item.createdAt | date:'medium' }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card shadow-sm border-0">
        <div class="card-body">
          <h5 class="mb-3">System Note</h5>
          <div class="text-muted small">
            Configure jurisdictions first, then tiers, then limits, then policies. The user-facing KYC wizard depends on this setup order.
          </div>
        </div>
      </div>
    </div>
  </div>

  <app-footer></app-footer>
</main>
</div>